





















































































import {
	PropType,
	computed,
	defineComponent,
	onMounted,
} from '@vue/composition-api';
import { FontAwesomeLayers, FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Size } from '../constants';

const DEFAULT_AVATAR = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAA1ADwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3+iiigAoqK5lMNtJKOqqTXFz6peXT72mZfQKcUAdzRXK6Nq0qXKwTMXWQ4BPUGuqoAKKKKACiiigCnqpI02bB/hrhh0rvryLz7OWMDJZSB9a4Mq0bFG6qcEUATWLBL+B2OFDjJrvAQQCOh6Vxej2qXeoqjk7VG/jv7V2gGAAOgoAWiiigAqK4uIrWIyzOFUdzUjMFBZjgAZJritVv5L27b5iYlOFXt9aANtvE1qrECKU+4FYGoXMd3eNNChRG7H1qrRQBLb3ElrKJYW2sP1rZg8TSBx58K7O5XrWDRQB21rq1pdlVSQK5/gPWr1eeIxjkV1OGByDXfwsHhRgc5Uc0AJcjNrKPVTXHLZR7RyaKKAF+xR+rUfYo/VqKKAD7FH6tR9ij9WoooADZR46tXU6UMabCMk8d6KKAP//Z';

export default defineComponent({
	components: {
		FontAwesomeIcon,
		FontAwesomeLayers,
	},
	props: {
		userName: {
			type: String,
			required: true,
		},
		src: {
			type: String,
			default: undefined,
		},
		alt: {
			type: String,
			default: undefined,
		},
		isVerified: Boolean,
		isAuthenticated: Boolean,
		hideVerificationStatus: Boolean,
		size: {
			type: String as PropType<Size>,
			default: Size.MEDIUM,
		},
	},
	setup(props, ctx) {
		onMounted(() => {
			ctx.emit('mounted');
		});
		const fallbackAlt = computed(() => `Avatar image for ${props.userName}`);
		return {
			Size,
			fallbackAlt,
			fallbackSrc: DEFAULT_AVATAR,
		};
	},
});
